import { HK_REGIONS_AND_DISTRICTS } from './hk-regions';

// Helper function to get localized region name
const getLocalizedRegionName = (regionCode: string, locale: string = 'zh-HK'): string => {
  const region = HK_REGIONS_AND_DISTRICTS.find(r => r.code === regionCode);
  if (!region) return regionCode;

  switch (locale) {
    case 'en':
      return region.name_en;
    case 'zh-CN':
      return region.name_zh_cn;
    case 'zh-HK':
    default:
      return region.name_zh_hk;
  }
};

// Helper function to get localized district name
const getLocalizedDistrictName = (regionCode: string, districtCode: string, locale: string = 'zh-HK'): string => {
  const region = HK_REGIONS_AND_DISTRICTS.find(r => r.code === regionCode);
  if (!region) return districtCode;

  const district = region.districts.find(d => d.code === districtCode);
  if (!district) return districtCode;

  switch (locale) {
    case 'en':
      return district.name_en;
    case 'zh-CN':
      return district.name_zh_cn;
    case 'zh-HK':
    default:
      return district.name_zh_hk;
  }
};

// Helper function to format full clinic address
export const getAddressString = (clinic: any, locale: string = 'zh-HK'): string => {
  const localizedRegion = clinic.region ? getLocalizedRegionName(clinic.region, locale) : '';
  const localizedDistrict = clinic.district && clinic.region ? 
    getLocalizedDistrictName(clinic.region, clinic.district, locale) : 
    clinic.district;

  const parts = [
    clinic.address,
    clinic.building_name,
    clinic.block,
    clinic.floor,
    clinic.unit,
    localizedDistrict,
    localizedRegion,
    clinic.postal_code
  ].filter(Boolean);
  
  return parts.join(', ');
};
